/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { css } from "@emotion/react";
import { MutateSalesChannelDrawer } from "./MutateSalesChannelDrawer";
import { colors } from "../../components/colors";
import { IconButton } from "../../components/IconButton";
import { Shop } from "./model/ShopSuccessResponse";
import { ButtonPrimary } from "../../components/NewButtons";
import { PlaceholderButton } from "../../components/PlaceholderButton";

type Props = {
  salesChannelId?: string;
  shop?: Shop;
  type: "create" | "update" | "placeholder";
};

const iconButtonStyle = css`
  color: ${colors.textSecondary};
  &:hover {
    color: ${colors.textPrimary};
  }
`;

export const MutateSalesChannelSelector = ({
  salesChannelId,
  shop,
  type,
}: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      {type === "create" && (
        <ButtonPrimary onClick={() => setModalOpen(true)} type="button">
          Create sales channel
        </ButtonPrimary>
      )}
      {type === "update" && (
        <IconButton
          onClick={() => setModalOpen(true)}
          type="button"
          css={iconButtonStyle}
          icon={<FontAwesomeIcon icon={solid("pen")} />}
        />
      )}
      {type === "placeholder" && (
        <PlaceholderButton
          type="button"
          icon={<FontAwesomeIcon icon={solid("arrow-right-arrow-left")} />}
          header="Click to create your first sales channel"
          subHeader="No sales channels created yet"
          onClick={() => setModalOpen(true)}
        />
      )}
      <MutateSalesChannelDrawer
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        salesChannelId={salesChannelId}
        shop={shop}
      />
    </div>
  );
};
